import { useConditionalEffect } from 'react-delta';
import { useRecoilState, useRecoilValue } from 'recoil';

import { useIsNewSearch } from 'hooks/useIsNewSearch';
import LRQRequestManager from 'components/common/Managers/LRQRequestManager';
import {
  completeFilterState,
  isCrossTeamSearchState,
  queryTimeRangeState,
  searchParamRecordState,
} from 'components/common/Managers/RouteStateManager.state';
import { plotDataRequestsState } from 'components/search/SearchLogsPage/SearchStateManager.state';
import { generateHistogramRequests, LRQRequest } from 'hooks/useLRQ/useLRQ';
import * as K from 'common/constants';

const DistributionPageStateManager = (): JSX.Element => {

  const isNewSearch = useIsNewSearch();
  const queryTimeRange = useRecoilValue(queryTimeRangeState);
  const { startTimeNs, endTimeNs, requestTime } = queryTimeRange;
  const isCrossTeamSearch = useRecoilValue(isCrossTeamSearchState);
  const searchParams = useRecoilValue(searchParamRecordState);
  const completeFilter = useRecoilValue(completeFilterState);
  const facet = searchParams[K.URL_PARAM.FACET] || '';
  const [plotDataRequests, setPlotDataRequests] = useRecoilState(plotDataRequestsState);
  const distributionRequest = generateHistogramRequests({
    startTime: startTimeNs,
    endTime:   endTimeNs,
    requestTime,
    facet,
    filter: completeFilter,
    teamEmails: isCrossTeamSearch ? searchParams?.teamEmails?.split(',') : undefined,
  });

  useConditionalEffect(() => {
    if (facet) {
      setPlotDataRequests(distributionRequest);
    }
  }, isNewSearch);

  if (!facet) {
    return <></>;
  }
  return (
    <>
      {(plotDataRequests as LRQRequest[]).map((request) => (
        <LRQRequestManager key={request.key} request={request} />
      ))}
    </>
  );
};

export default DistributionPageStateManager;
